import { useSelector, shallowEqual } from 'react-redux';
import moment from 'moment';

import {
  selectMoveInDate,
  selectIsLoading,
  selectErrorsToBeDisplayed,
  selectSupplyStartDate
} from 'state/move-in-date/move-in-date-slice';
import { MOVE_IN_DATE, DATE_FORMAT } from 'config/app-config';
import { selectedAddress } from 'state/selected-address/selected-address-slice';
import { MoveInPreSSDError } from 'errors/MoveInDateError';

export const useMoveInDate = () => {
  const today = moment();

  const supplyStartDate = useSelector(selectSupplyStartDate, shallowEqual);
  const isLoading = useSelector(selectIsLoading, shallowEqual);
  const selectedMoveInDate = useSelector(selectMoveInDate, shallowEqual);
  const currentAddress = useSelector(selectedAddress, shallowEqual);
  const errors = useSelector(selectErrorsToBeDisplayed, shallowEqual);
  const udprn = currentAddress?.udprn;
  const hasMoveInPreSSDError = errors?.some(
    (error) => error.name === MoveInPreSSDError.name
  );
  const defaultMinimumMoveInDate = moment(today)
    .subtract(MOVE_IN_DATE.ALLOWED_DAYS_IN_PAST, 'days')
    .format(DATE_FORMAT);

  const maximumMoveInDate = moment(today).format(DATE_FORMAT);
  const minimumMoveInDate = supplyStartDate || defaultMinimumMoveInDate;

  return {
    maximumMoveInDate,
    minimumMoveInDate,
    selectedMoveInDate,
    isLoading,
    udprn,
    errors,
    hasMoveInPreSSDError
  };
};
